import {
  FETCH_PLATFORM_SETTINGS_PUBLIC,
  FETCH_PLATFORM_SETTINGS_ADMIN,
  UPDATE_PLATFORM_SETTINGS,
} from '../actions/types/platformSettingsTypes';
import {
  FAILED,
  STARTED,
  SUCCEEDED,
  getFailed,
  getStarted,
  getSucceeded,
} from '../../utils/helpers/store-helpers';

const initialState = {
  public: null,
  admin: null,
  fetchPublicStatus: '',
  fetchAdminStatus: '',
  updateStatus: '',
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getStarted(FETCH_PLATFORM_SETTINGS_PUBLIC):
      return { ...state, fetchPublicStatus: STARTED };
    case getFailed(FETCH_PLATFORM_SETTINGS_PUBLIC):
      return { ...state, fetchPublicStatus: FAILED };
    case getSucceeded(FETCH_PLATFORM_SETTINGS_PUBLIC):
      return { ...state, public: payload, fetchPublicStatus: SUCCEEDED };

    case getStarted(FETCH_PLATFORM_SETTINGS_ADMIN):
      return { ...state, fetchAdminStatus: STARTED };
    case getFailed(FETCH_PLATFORM_SETTINGS_ADMIN):
      return { ...state, fetchAdminStatus: FAILED };
    case getSucceeded(FETCH_PLATFORM_SETTINGS_ADMIN):
      return { ...state, admin: payload, fetchAdminStatus: SUCCEEDED };

    case getStarted(UPDATE_PLATFORM_SETTINGS):
      return { ...state, updateStatus: STARTED };
    case getFailed(UPDATE_PLATFORM_SETTINGS):
      return { ...state, updateStatus: FAILED };
    case getSucceeded(UPDATE_PLATFORM_SETTINGS):
      return {
        ...state,
        admin: payload,
        public: {
          inactivityTimeoutMinutes: payload?.inactivityTimeoutMinutes,
          inactivityWarningMinutes: payload?.inactivityWarningMinutes,
        },
        updateStatus: SUCCEEDED,
      };

    default:
      return state;
  }
};

export default reducer;
